import { type TrackingEventRequestPayload } from '@lightdash/common';
import { useCallback } from 'react';
import { sortmentApi } from '../api';
import { type EventData } from '../types/Events';

export function useTracking() {
    const track = useCallback((event: EventData, projectUuid: string): void => {
        try {
            if (!projectUuid) {
                console.warn(
                    'No project UUID found for tracking event:',
                    event.name,
                );
                return;
            }

            const payload: TrackingEventRequestPayload = {
                eventName: event.name,
                payload: event.payload || {},
                timestamp: new Date().toISOString(),
                userAgent: navigator.userAgent,
                url: window.location.href,
                referrer: document.referrer,
            };

            sortmentApi({
                method: 'POST',
                url: `/projects/${projectUuid}/events/tracking`,
                body: JSON.stringify(payload),
                keepalive: true, // Keep request alive even if page unloads
            }).catch((error) => {
                console.warn(
                    'Failed to send tracking request for event:',
                    event.name,
                    error,
                );
            });
        } catch (error) {
            console.warn('Error tracking event:', event.name, error);
        }
    }, []);

    return {
        track,
    };
}
